import { LLMTemplatesContainer } from '@/modules/LLMTemplates';

export const LLMTemplates = (): JSX.Element => <LLMTemplatesContainer />;

export default LLMTemplates;
